'use client';

import { ReactNode } from 'react';

import { TITLE_COLOR_CLASS } from '@/components/layout/titleStyles';
import { cn } from '@/lib/utils';

/**
 * `sm` names a block inside a page; `md` names a panel or drawer, which opens over one;
 * `lg` names a block that IS the page's content, as the Visão executiva's cards are, where
 * the question itself is what the reader looks for first.
 */
type SectionTitleSize = 'sm' | 'md' | 'lg';

const SIZE_CLASS: Record<SectionTitleSize, string> = {
  sm: 'text-sm font-semibold',
  md: 'text-base font-semibold',
  lg: 'text-lg font-semibold',
};

interface SectionTitleProps {
  children: ReactNode;
  size?: SectionTitleSize;
  /** Heading level: 3 when the block already sits under an `h2`, so the outline stays in order. */
  level?: 2 | 3;
  className?: string;
}

/**
 * The name of a block or panel, in the title colour. Every screen uses this instead of its own
 * heading, so the colour is decided once for the whole app.
 */
export function SectionTitle({ children, size = 'sm', level = 2, className }: SectionTitleProps) {
  const Tag = level === 3 ? 'h3' : 'h2';

  return <Tag className={cn(SIZE_CLASS[size], TITLE_COLOR_CLASS, className)}>{children}</Tag>;
}
